import OrderModal from "@/models/Order";

const GET_ORDER_CONFIRM = 'GET_ORDER_CONFIRM';
const GET_ORDER_CONFIRM_AMOUNT = 'GET_ORDER_CONFIRM_AMOUNT';
const SET_ORDER_CONFIRM_INFO = 'SET_ORDER_CONFIRM_INFO';
const SUBMIT_ORDER_CONFIRM = 'SUBMIT_ORDER_CONFIRM';
const CLEAR_ORDER_CONFIRM_INFO = 'CLEAR_ORDER_CONFIRM_INFO';
const GET_SKU_STOCK_PRICE_MONTH_LIST = 'GET_SKU_STOCK_PRICE_MONTH_LIST';
const CHECK_TRADE_AMOUNT_NEW = 'CHECK_TRADE_AMOUNT_NEW';
const APPLY_BILL = 'APPLY_BILL';
const GET_PHONE_PREFIX = 'GET_PHONE_PREFIX';
const GET_BILL_CATE = 'GET_BILL_CATE';

/**
 * 获取订单确认页信息
 * @param {Object} selectedInfo 选中套餐信息
 */
async function getOrderConfirm(selectedInfo) {
  const payload = await new OrderModal().comfirmOrder(selectedInfo);
  return {
    type: GET_ORDER_CONFIRM,
    payload
  }
}

/**
 * 获取订单确认页金额信息
 */
async function getOrderConfirmAmount(params) {
  const payload = await new OrderModal().checkOrderAmout(params);
  return {
    type: GET_ORDER_CONFIRM_AMOUNT,
    payload
  }
}

/**
 * 设置订单确认页填写的信息
 * @param {Object} info 填写的信息
 */
async function setOrderConfirmInfo(info) {
  return {
    type: SET_ORDER_CONFIRM_INFO,
    payload: info
  }
}

/**
 * 提交云闪付订单
 * @param {Object} params 订单参数
 */
async function submitOrderConfirm(params) {
  const payload = await new OrderModal().submitOrder(params);
  return {
    type: SUBMIT_ORDER_CONFIRM,
    payload
  }
}

/**
 * 清除订单确认页填写的信息
 */
async function clearOrderConfirmInfo() {
  return {
    type: CLEAR_ORDER_CONFIRM_INFO
  }
}

/**
 * 获取商品sku全部可售卖月份
 */
async function getSkuStockPriceMonthList(params) {
  const payload = await new OrderModal().getSkuStockPriceMonthList(params);
  return {
    type: GET_SKU_STOCK_PRICE_MONTH_LIST,
    payload
  }
}

/**
 * 计算订单金额(新)
 */
async function checkTradeAmountNew(params) {
  const payload = await new OrderModal().checkTradeAmountNew(params);
  return {
    type: CHECK_TRADE_AMOUNT_NEW,
    payload
  }
}

/**
 * 申请发票
 */
async function applyBill(params) {
  const payload = await new OrderModal().applyBill(params);
  return {
    type: APPLY_BILL,
    payload
  }
}

/**
 * 查询发票类型
 */
async function getBillCate(params) {
  const payload = await new OrderModal().getBillCate(params);
  return {
    type: GET_BILL_CATE,
    payload
  }
}

/**
 * 获取手机号区号
 */
async function getPhonePrefix(params) {
  const payload = await new OrderModal().getPhonePrefix(params);
  return {
    type: GET_PHONE_PREFIX,
    payload
  }
}

const ACTION_TYPES = {
  GET_ORDER_CONFIRM,
  GET_ORDER_CONFIRM_AMOUNT,
  SET_ORDER_CONFIRM_INFO,
  SUBMIT_ORDER_CONFIRM,
  CLEAR_ORDER_CONFIRM_INFO,
  GET_SKU_STOCK_PRICE_MONTH_LIST,
  CHECK_TRADE_AMOUNT_NEW,
  APPLY_BILL,
  GET_PHONE_PREFIX,
  GET_BILL_CATE,
};

const ACTION = {
  getOrderConfirm,
  getOrderConfirmAmount,
  setOrderConfirmInfo,
  submitOrderConfirm,
  clearOrderConfirmInfo,
  getSkuStockPriceMonthList,
  checkTradeAmountNew,
  applyBill,
  getPhonePrefix,
  getBillCate,
};

const OrderConfirm = {
  ACTION_TYPES,
  ACTION
}

export default OrderConfirm;